const types = {
  LOAD: 'app/payment/LOAD',
  LOAD_SUCCESS: 'app/payment/LOAD_SUCCESS',
  LOAD_FAIL: 'app/payment/LOAD_FAIL',
};

export default types;
